<script setup lang="ts">
import type { PreparedAuctionItem } from '@autobid/ui/types/components/AuctionsData'
import Designations from './element/Designations.vue'

const auction = inject<PreparedAuctionItem>('auction')
</script>

<template>
  <div
    v-if="auction"
    class="flex h-full w-full flex-col items-center justify-center bg-white p-2 group-hover:bg-slate-100"
  >
    <span v-if="auction.stage !== 'IN_PREPARATION'" class="text-4xl">{{ auction.count }}</span>
    <Designations v-if="auction.designations?.length" :designations="auction.designations" />
    <Icon
      v-if="auction.nationality !== 'NATIONAL' && auction.country?.isoCode"
      mode="svg"
      :name="`cif:${auction.country.isoCode.toLowerCase()}`"
      class="h-[40px] w-[60px] self-start"
      :title="auction.country.name"
    />
  </div>
</template>
